import * as React from 'react'
import { observer } from 'mobx-react-lite'
import { animated, useSpring } from '@react-spring/web'
import { useMatch } from '@reach/router'
import styled from 'styled-components'
import { useApi } from 'src/api'
import { RouteState } from 'src/constants/routes'
import TextArea from 'react-textarea-autosize'

const StyledSidebarNavigation = animated(styled.textarea`
  width: 320px;
  padding: 0px 16px;
  margin:0;
  box-sizing: border-box;
  position: relative;
  height: 64px;
  line-height: 64px;
  color: rgb(255, 255, 255);
  text-overflow: ellipsis;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  border: none;
  outline:none;
}
`)

type SidebarNavigationProps = {
  routeState: RouteState
}

const StyledAnimatedTextArea = styled(animated.textarea)`
  resize: none;
  height: 32px;
  border: none;
  outline: none;
  resize: none;
  text-overflow: ellipsis;
  text-align: center;
  background-color: rgba(0, 0, 0, 0);
  margin: 0px;
  box-sizing: border-box;
  color: rgba(255, 255, 255, 1);
`

const TitleInput = styled(StyledAnimatedTextArea)`
  font-size: 16px;
  line-height: 16px;
  padding: 16px 8px 0px 8px;
`

const StyledAnimatedWrapper = animated(styled.aside`
  width: 320px;
  margin: 0;
  box-sizing: border-box;
  position: relative;
  height: 64px;
  line-height: 64px;
  color: rgb(255, 255, 255);
  white-space: nowrap;
  border: none;
  display: flex;
  flex-direction: column;
`)

const compactStyle = {
  // whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden'
}

const focusedStyle = {
  // whiteSpace: 'wrap',
  overflow: 'visible',
  resize: 'vertical'
}

const DescriptionWrapper = styled(animated.div)`
  z-index: 5;
  background-color: inherit;
  display: flex;
  & > textarea {
    width: 100%;
    box-sizing: border-box;
    font-size: 12px;
    line-height: 12px;
    font-style: italic;
    font-weight: thin;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding-top: 0px;
    padding-bottom: 8px;
    padding-right: 32px;
    padding-left: 32px;
    margin: 0;
    resize: none;
    cursor: pointer;
    outline: none;
    border: none;
    border-width: 0px;
    background-color: inherit;
    color: inherit;
    max-height: 22px;
    &:focus {
      cursor: text;
      overflow: visible;
      white-space: break-spaces;
      max-height: 100vh;
    }
    &::placeholder {
      text-align: center;
    }
  }
`

const TitleWrapper = styled(DescriptionWrapper)`
  min-height: 42px;
  & > textarea {
    font-size: 16px;
    font-weight: normal;
    line-height: 16px;
    padding-top: 16px;
    padding-bottom: 0;
    padding-right: 8px;
    padding-left: 8px;
    font-style: normal;
    text-align: center;
    max-height: 42px;
    &:focus {
      max-height: 100vh;
      padding-top: 16px;
      padding-bottom: 0;
      padding-right: 8px;
      padding-left: 8px;
    }
  }
`

const SidebarNavigation: React.FC<SidebarNavigationProps> = ({
  routeState
}) => {
  const { width, backgroundColor } = useSpring({
    width: routeState.state?.name === 'summary' ? 640 : 320,
    backgroundColor: routeState.state?.name === 'editor' ? '#346b6e' : '#3F8487'
  })
  // const project = useApi(store => store.getProject(projectID))
  const projectName = routeState.view?.draft.properties.name
  const projectDescription = routeState.view?.draft.properties.description
  return (
    <StyledAnimatedWrapper {...{ style: { width, backgroundColor } }}>
      <TitleWrapper>
        <TextArea
          {...{
            maxRows: 10,
            onChange: (e) => {
              projectName.update(e.target.value)
            },
            placeholder: 'unnamed project',
            value: projectName.value
          }}
        />
      </TitleWrapper>
      <DescriptionWrapper>
        <TextArea
          {...{
            maxRows: 20,
            onChange: (e) => {
              projectDescription.update(e.target.value)
            },
            placeholder: 'give your project a description...',
            value: projectDescription.value
          }}
        />
      </DescriptionWrapper>
    </StyledAnimatedWrapper>
  )
}

const ObservedSidebarNavigation = observer(SidebarNavigation)

export { ObservedSidebarNavigation as SidebarNavigation }
